function customHeaderOnLoad(cus_phone) {
  var settings = {
    url: "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/auth/token",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      api_key: "4940F195-2EAD-42A1-84FE-55A6B4416FE6",
      client: "magenest",
    }),
  };

  $.ajax(settings).done(function (response) {
    supara_token = response.data.token;
    var ajax_reward = {
      url:
        "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/magenest/customers/get?mobile=" +
        parseInt(cus_phone) +
        "&source=INSTORE",
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + supara_token,
      },
    };
    $.ajax(ajax_reward).done(function (response) {
      document.getElementById("loggedOut").style.display = "none";
      // document.getElementById("loggedIn").style.display = "";
      $('#loggedIn').show();

      document.getElementsByClassName('header-membership')[0].style.backgroundColor  = "unset";
      document.getElementsByClassName('header-membership')[0].style.border = "unset";
      // document.getElementById("memberName").style.color = "#FFFFFF";
      document.getElementsByClassName('header-membership-btn')[0].style.background = "unset";
      document.getElementsByClassName('header-membership-btn')[0].style.border = "unset";
      document.getElementsByClassName('header-membership-btn')[0].style.fontWeight = "bold";
      document.getElementsByClassName('header-membership-btn')[0].style.marginLeft = "unset";
      if( response.data.first_name_en == null){
        var first_name = response.data.first_name_th;
      } else{
        var first_name = response.data.first_name_en;
      }
      document.getElementById("memberName").innerText =
        "Hi! " + first_name + ",";
      if(response.data.points.length > 0){
        point = response.data.points[0].point_balance.toLocaleString('en-US');
      } else {
        point = 0;
      }
      member_point_html = '<img src="https://cdn.shopify.com/s/files/1/0631/7755/6173/files/GQ-Coin.png?v=1715157282" style="width:15px; margin-top: 5px;">' + ' ' + point;
      document.getElementById("memberBtn").innerHTML = member_point_html;

      document.getElementsByClassName('header-membership')[1].style.backgroundColor  = "unset";
      document.getElementsByClassName('header-membership')[1].style.border = "unset";
      // document.getElementById("memberName2").style.color = "#FFFFFF";
      document.getElementsByClassName('header-membership-btn')[1].style.background = "unset";
      document.getElementsByClassName('header-membership-btn')[1].style.border = "unset";
      document.getElementsByClassName('header-membership-btn')[1].style.fontWeight = "bold";
      document.getElementsByClassName('header-membership-btn')[1].style.marginLeft = "unset";
      document.getElementById("memberName2").innerText =
        "Hi! " + first_name + ",";
      // if(response.data.points.length > 0){
      //   point = response.data.points[0].point_balance;
      // } else {
      //   point = 0;
      // }
      member_point_html_2 = '<img src="https://cdn.shopify.com/s/files/1/0631/7755/6173/files/GQ-Coin.png?v=1715157282" style="width:15px; margin-top: 5px;">' + ' ' + point;
      document.getElementById("memberBtn2").innerHTML = member_point_html_2;
      
    });
  });
}
